import {observeWindowResize} from '../utils'

export const onWindowResize = (callback) => {
  const width = window.innerWidth
  callback({width})
  observeWindowResize(() => {
    const width = window.innerWidth
    callback({width})
  })
}
